export default {
  props:['item'],
  name: "category-card"
}